<template lang="pug">
  .pho-color-picker-input
    .row
      .col.col-10
        PhoTextField(
          v-model="lazyValue"
          :rules="inputRules"
          :outlined="outlined"
          :label="label"
        )
      .col.col-2
        .color-preview(
          :class="`${(outlined ? 'color-preview-outlined' : '')}`"
          :style="previewStyle"
          @click.stop="edit"
        )
    Dialog(
      v-model="dialog.dialog.isActive.value"
      max-width="350"
      :title="$t($lang.app.PICK_COLOR)"
      @close="dialog.close"
    )
      template(v-slot:dialog-content)
        v-color-picker.mt-4.d-block(
          v-model="dialog.lazyValue.value"
          hide-inputs
          hide-mode-switch
          :dot-size="dotSize"
          :mode="mode"
        )
        PhoTextField(
          v-model="dialog.lazyValue.value"
          readonly
          :outlined="outlined"
          :label="$t($lang.app.COLOR)"
        )
      template(v-slot:dialog-actions)
        v-btn(color="green darken-1 white--text" @click="save")
          | {{ $t($lang.app.SAVE) }}
        v-btn(color="error darken-1 white--text" @click="cancel")
          | {{ $t($lang.app.CANCEL) }}
</template>
<script>
import { computed } from 'vue';
import { useModelAutoBinding } from '@/helpers/misc/binding';
import { usePromisifiedDialog } from '@/helpers/misc/dialog';
import { Dialog } from '@/components/misc/dialog';
import PhoTextField from './PhoTextField.vue';

const defaultColor = '';

export default {
  name: 'PhoColorPickerInput',
  components: {
    PhoTextField,
    Dialog,
  },
  props: {
    value: {
      type: String,
      default: defaultColor,
    },
    label: {
      type: String,
      default: '',
    },
    outlined: {
      type: Boolean,
      default: true,
    },
    dotSize: {
      type: String,
      default: '25',
    },
    mode: {
      type: String,
      default: 'hexa',
    },
    name: {
      type: String,
      default: '',
    },
    rules: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const { lazyValue } = useModelAutoBinding(emit, props);
    const dialog = usePromisifiedDialog(props.value);

    const previewStyle = computed(() => (lazyValue.value ? `background-color:${lazyValue.value}` : `background-color:${defaultColor}`));
    const inputRules = computed(() => `hexColor${props.rules ? `|${props.rules}` : '' }`);

    const edit = async () => {
      lazyValue.value = await dialog.edit(lazyValue.value || defaultColor);
    };

    const close = () => {
      dialog.clear();
      dialog.close();
    };

    const save = () => {
      dialog.save();
      close();
    };

    const cancel = () => {
      dialog.lazyValue.value = lazyValue.value;
      dialog.save();
      close();
    };

    return {
      lazyValue,
      dialog,
      previewStyle,
      inputRules,
      edit,
      save,
      cancel,
    };
  },
};
</script>
